import { api } from './api';

export const fetchSubscriptions = (params, options) => {
  return api.get('/subscription', params, options);
};

export const fetchSubscriptionsPeriods = (params) => {
  return api.get('/subscription/period', params);
};

export const fetchSubscriptionById = (id) => {
  return api.get(`/subscription/${id}`);
};

export const fetchChangeVehicle = (id, payload) => {
  return api.post(`/subscription/${id}/vehicle`, payload);
};

export const fetchCancelSubscription = (id) => {
  return api.post(`/subscription/${id}/cancel`);
};

export const fetchUpdateSubscriptionQualifications = (id, payload) => {
  return api.post(`/subscription/${id}/qualification`, payload);
};

export const fetchUpdateExchange = (id, payload) => {
  return api.post(`/subscription/${id}/exchange`, payload);
};

export const fetchUpdateSubscription = (id, payload) => {
  return api.put(`/subscription/${id}`, payload);
};

export const fetchSubscriptionPricing = (id, payload) => {
  return api.get(`/subscription/${id}/pricing`, payload);
};

export const fetchAggregates = (payload = {}) => {
  return api.get(`/subscription/statistic`, payload);
};

export const fetchAggregatesTotals = (payload = {}) => {
  return api.get(`/subscription/statistic/totals`, payload);
};
